const isExplicitlyRelative = importPath => {
  return importPath.indexOf(".") === 0;
};

module.exports = {
  isExplicitlyRelative
};



//////////////////
// WEBPACK FOOTER
// ./packages/truffle-compile/profiler/isExplicitlyRelative.js
// module id = 2043
// module chunks = 0 1